module.exports = __webpack_public_path__ + "img/reelables-r-logo-white.3344523c.svg";